module.exports = __webpack_public_path__ + "img/course_0013.3974891.png";